var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "main" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading",
          },
        ],
      },
      [_c("v-page-loading")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLoading,
            expression: "!isLoading",
          },
        ],
      },
      [
        _c("v-page-header", { attrs: { title: _vm.getPageTile } }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasLoadingError,
                expression: "hasLoadingError",
              },
            ],
          },
          [
            _c("div", { staticClass: "grid-container" }, [
              _c("p", { staticClass: "text-center" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.loadingError) +
                    "\n                "
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.hasLoadingError,
                expression: "!hasLoadingError",
              },
            ],
          },
          [
            _c("div", { staticClass: "grid-container" }, [
              _c("div", { staticClass: "grid-x" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "cell medium-9 medium-offset-1 large-11 large-offset-0",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "wrapper" },
                      [
                        _c("v-action-buttons", {
                          attrs: { items: _vm.getActionButtons },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "box" },
                          [
                            _c("v-navigation"),
                            _vm._v(" "),
                            _c(
                              "form",
                              {
                                staticClass: "filter filter--search",
                                attrs: {
                                  action: "",
                                  method: "POST",
                                  novalidation: "",
                                },
                                on: {
                                  submit: _vm.onChangeLocationsTableFilter,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-group--search",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value:
                                            _vm.locationsTableFilter.search,
                                          expression:
                                            "locationsTableFilter.search",
                                        },
                                      ],
                                      staticClass:
                                        "form-control form-control--small form-control--search",
                                      attrs: {
                                        type: "text",
                                        placeholder: _vm.$t("search.term"),
                                      },
                                      domProps: {
                                        value: _vm.locationsTableFilter.search,
                                      },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.locationsTableFilter,
                                            "search",
                                            $event.target.value
                                          )
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button",
                                        attrs: {
                                          role: "button",
                                          type: "submit",
                                          title: _vm.$t("search"),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(_vm.$t("search")) +
                                            "\n                                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("v-blocks", {
                              attrs: {
                                id: "blocks",
                                isLoading: _vm.locationsTableLoading,
                                items: _vm.locationsTableItems,
                                useDeactivatedSwitch: true,
                                showDeactivatedOnly:
                                  _vm.locationsTableFilter
                                    .show_deactivated_only,
                              },
                              on: {
                                onChangeShowDeactivatedOnly:
                                  _vm.onChangeShowDeactivatedOnlyLocationsTableFilter,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "block",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "block block--block",
                                          attrs: {
                                            to: {
                                              name: "customers-view-customer-location",
                                              params: {
                                                customer:
                                                  _vm.$route.params.customer,
                                                location: row.id,
                                              },
                                            },
                                            title: row.company_name,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "block--block__content",
                                            },
                                            [
                                              _c("h2", [
                                                _vm._v(
                                                  _vm._s(row.company_name)
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              row.is_hq === true
                                                ? _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "customers.hq_location"
                                                        )
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "customers.location_number"
                                                    )
                                                  ) +
                                                    ": " +
                                                    _vm._s(row.location_number)
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(_vm._s(row.phone)),
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(_vm._s(row.email)),
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(row.address1)
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(row.address2)
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(row.zipcode) +
                                                    " " +
                                                    _vm._s(row.city)
                                                ),
                                                _c("br"),
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(
                                                      _vm.$helpers.countries[
                                                        row.country_code
                                                      ]
                                                    ) +
                                                    "\n                                                "
                                                ),
                                              ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.$store.getters.userIsAdmin
                                            ? [
                                                row.risk
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "block--block__content location--risk",
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "location.risk.risk_number"
                                                                  )
                                                                ) +
                                                                  ": " +
                                                                  _vm._s(
                                                                    row.risk
                                                                      .risk_number
                                                                  )
                                                              ),
                                                            ]),
                                                            _c("br"),
                                                            _vm._v(" "),
                                                            row.risk
                                                              .decided_budget
                                                              ? [
                                                                  _vm._v(
                                                                    "\n                                                        " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "location.risk.limit"
                                                                        )
                                                                      ) +
                                                                      ": " +
                                                                      _vm._s(
                                                                        _vm.$helpers.formateCurrency(
                                                                          row
                                                                            .risk
                                                                            .decided_budget
                                                                        )
                                                                      ) +
                                                                      "\n                                                    "
                                                                  ),
                                                                ]
                                                              : [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "u-color--alert",
                                                                    },
                                                                    [
                                                                      _c("br"),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "strong",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "location.risk.decided_budget.not_exist"
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                            _vm._v(" "),
                                                            row.risk.valid_from
                                                              ? [
                                                                  _c("br"),
                                                                  _vm._v(
                                                                    "\n                                                        " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "location.risk.valid_from"
                                                                        )
                                                                      ) +
                                                                      ": " +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "moment"
                                                                        )(
                                                                          row
                                                                            .risk
                                                                            .valid_from,
                                                                          "DD.MM.YYYY"
                                                                        )
                                                                      ) +
                                                                      "\n                                                    "
                                                                  ),
                                                                ]
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            row.risk.valid_until
                                                              ? [
                                                                  _c("br"),
                                                                  _vm._v(
                                                                    "\n                                                        " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "location.risk.valid_until"
                                                                        )
                                                                      ) +
                                                                      ": " +
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "moment"
                                                                        )(
                                                                          row
                                                                            .risk
                                                                            .valid_until,
                                                                          "DD.MM.YYYY"
                                                                        )
                                                                      ) +
                                                                      "\n                                                    "
                                                                  ),
                                                                ]
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            !row.risk.is_valid
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "u-color--alert",
                                                                  },
                                                                  [
                                                                    _c("br"),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "location.risk.not_valid"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          2
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "u-color--alert block--block__content",
                                                      },
                                                      [
                                                        _c("p", [
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "location.risk.no_risk_number"
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                        ]),
                                                      ]
                                                    ),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "block--block__action",
                                            },
                                            [
                                              _vm.$store.getters.userHasPermission(
                                                "location_update"
                                              )
                                                ? [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        staticClass:
                                                          "button gray-dark button--edit",
                                                        attrs: {
                                                          to: {
                                                            name: "customers-update-customer-location",
                                                            params: {
                                                              customer:
                                                                _vm.$route
                                                                  .params
                                                                  .customer,
                                                              location: row.id,
                                                            },
                                                          },
                                                          title:
                                                            _vm.$t("update"),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                        " +
                                                            _vm._s(
                                                              _vm.$t("update")
                                                            ) +
                                                            "\n                                                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ],
                                        2
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("v-pagination", {
                              attrs: {
                                currentPage: _vm.locationsTableCurrentPage,
                                itemsPerPage: _vm.locationsTableItemsPerPage,
                                items: _vm.locationsTableItemsCount,
                              },
                              on: {
                                pageClicked: _vm.onChangeLocationsTablePage,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }